import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";

import { useAuthContext } from "../context/AuthContext";
import { getSocket } from "../helper/socket";
const PrivateRoute = ({ children }) => {
  const { userProfile } = useAuthContext();
  let token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;

  // useEffect(() => {
  //   if (userProfile?._id) {
  //     const socket = getSocket();
  //     socket.emit("supportOnline", { userId: userProfile._id });
  //     const handleTabClose = () => {
  //       socket.emit("supportOffline", { userId: userProfile._id });
  //     };
  //     window.addEventListener("beforeunload", handleTabClose);
  //     return () => {
  //       socket.emit("supportOffline", { userId: userProfile._id });
  //       window.removeEventListener("beforeunload", handleTabClose);
  //     };
  //   }
  // }, []);

  return token ? (
    <>
      <Main>{children}</Main>
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
